import styles from './styles/FilterWrapper.module.scss';
import React from 'react';
import { Ssvg } from '../../../Components/react/Ssvg';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { FACET_KEY_MEDIUMS } from '../../constants/facetKeys';
import { SEARCH_PARAM_KEY_PAGE_NUMBER } from '../../constants/searchParamKeys';
import { useAlgoliaAppContext } from '../../hooks/useAlgoliaAppContext';
import { handleize } from '../../../js/helpers/handleize';
export const FilterWrapper = ({ fConfig, children }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const { medium, handle } = useParams();
    const { pagePath } = useAlgoliaAppContext();
    const navigate = useNavigate();
    searchParams.delete(SEARCH_PARAM_KEY_PAGE_NUMBER);
    let hasActiveFilter = false;
    let clearFacet = () => {
        if (fConfig.hierarchy !== undefined) {
            for (let i = 1; i <= fConfig.hierarchy; i++) {
                searchParams.delete(`${fConfig.key}_lv${i}`);
            }
        }
        else {
            searchParams.delete(fConfig.key);
        }
        searchParams.sort();
        setSearchParams(searchParams);
    };
    if (fConfig.key === FACET_KEY_MEDIUMS) {
        hasActiveFilter = medium !== undefined;
        clearFacet = () => {
            const searchString = searchParams.toString();
            navigate({
                pathname: `/${pagePath}/${handle ?? ''}`,
                ...(searchString.length > 0 && { search: `?${searchString}` })
            });
        };
    }
    else if (fConfig.hierarchy !== undefined) {
        for (let i = 1; i <= fConfig.hierarchy; i++) {
            if (searchParams.has(`${fConfig.key}_lv${i}`)) {
                hasActiveFilter = true;
                break;
            }
        }
    }
    else if (searchParams.has(fConfig.key)) {
        hasActiveFilter = true;
    }
    const itemsWrapperStyle = fConfig.style === 'colors'
        ? styles.colorsItemsWrapper
        : fConfig.style === 'icons'
            ? styles.iconsItemsWrapper
            : fConfig.style === 'static_tree'
                ? styles.staticItemsWrapper
                : styles.listItemsWrapper;
    return (React.createElement("accordion-component", { class: `d:block w:100 pos:r ${styles.facet}` },
        React.createElement("button", { className: `btn:cleared pos:r z:1 w:100 text:left fw:700 d:flex ai:center ${styles.headButton}`, "aria-expanded": 'true', "aria-controls": `facet-${handleize(fConfig.name)}` },
            React.createElement("span", { className: "sr-only" }, "Filter by "),
            React.createElement("span", null, fConfig.name),
            React.createElement(Ssvg, { icon: "#icon--arrow-down", className: `pos:a r:0 t:50 trf:ty:-50 lh:0 trs:all:300 ${styles.headButtonArrow}` })),
        hasActiveFilter &&
            React.createElement("button", { className: `btn:cleared fw:700 pos:a z:2 ${styles.headClearButton}`, "aria-label": `Clear filters by ${fConfig.name}`, onClick: clearFacet },
                React.createElement(Ssvg, { icon: "#icon--clear-x", className: styles.headClearButtonIcon }),
                " CLEAR"),
        React.createElement("div", { id: `facet-${handleize(fConfig.name)}`, className: `ov:h trs:all:300 ${styles.itemsContainer}`, "data-state-expanded": true },
            React.createElement("div", { className: itemsWrapperStyle }, children))));
};
